import { createLogger } from 'redux-logger';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { createStore, combineReducers, applyMiddleware } from 'redux';

import { config } from './configuration';

// Import feature reducers
import toastReducer from '~features/toast/ducks';
import reducer from './reducers/rootReducer';
import transferReducers from './reducers/transferReducers';
import messageReducer from './reducers/messageReducer';
import errorReducer from './reducers/errorReducer';
import drawerReducer from '~features/drawer/ducks';
import userReducer from '~features/user/ducks';
import printOrderReducer from '~features/printOrder/ducks';
import webshopReducer from '~features/webshop/ducks';
import modalsReducer from '~features/modals/ducks';
import projectsReducer from '~features/projects/ducks';
import formReducer from './forms/ducks';

const loggerMiddleware = createLogger();

const rootReducer = combineReducers({
  reducer,
  errorReducer,
  transferReducers,
  messageReducer,
  toast: toastReducer,
  drawer: drawerReducer,
  user: userReducer,
  print: printOrderReducer,
  webshop: webshopReducer,
  modals: modalsReducer,
  projects: projectsReducer,
  form: formReducer,
});

export const store = createStore(
  rootReducer,
  composeWithDevTools(
    config.loggingEnabled
      ? applyMiddleware(loggerMiddleware, thunk)
      : applyMiddleware(thunk)
  )
);
